function getDomainMapKeyFromInstancePathReduxUtil (path) {
  const key = path.slice(path.lastIndexOf('.') + 1)
  return !isNaN(key) ? parseInt(key, 10) : key
}

export {
  getDomainMapKeyFromInstancePathReduxUtil
}
